<template>
  <div>
    <navigation-sub
      :list="[
        {
          title: $t('culture.store.name')
        },
        {
          title: $t('culture.font.name')
        },
        {
          title: $t('culture.music.name')
        }
      ]"
    />

    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.culture') }}</h4>
    </section>

    <section class="service-list">
      <!-- 배민문방구 -->
      <article :id="hashTitle($t('culture.store.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('culture.store.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/goods.png" :alt="$t('culture.store.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/logo_goods.png" :alt="$t('culture.store.name')">
            <html-view tag="p" :value="$t('culture.store.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('culture.store.content')" />
          </div>
        </div>
      </article>

      <!-- 글꼴 -->
      <article :id="hashTitle($t('culture.font.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('culture.font.name')">
          <div class="service-box-image">
            <p>
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/service/font.gif">
                <source media="(max-width: 750px)" srcset="~@/static/image/service/font.gif">
                <img src="~@/static/image/service/font.gif" :alt="$t('culture.font.name')">
              </picture>
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/logo_font.png" :alt="$t('culture.font.name')">
            <html-view tag="p" :value="$t('culture.font.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('culture.font.content')" />
            <div class="btn-wrap">
              <router-link
                :to="{ name: 'Fonts', params : { locale: $route.params.locale }}"
                class="btn-link"
              >
                {{ $t('culture.font.site') }}<icon-blank />
              </router-link>
              <!--<a
                href="/"
                class="btn-link"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '컬처',
                  label: '서비스링크_글꼴',
                  page: '서비스'})"
              >{{ $t('culture.font.site') }}<icon-blank /></a>-->
            </div>
          </div>
        </div>
      </article>

      <!-- 음악 -->
      <article :id="hashTitle($t('culture.music.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('culture.music.name')">
          <div class="service-box-image">
            <p>
              <video
                muted
                loop
                autoplay
                playsinline
                poster="~@/static/image/music/pc/robot-fantasia.jpg"
              >
                <source src="~@/static/video/robot_fantasia.mp4" type="video/mp4">
                Sorry, your browser doesn't support embedded videos.
              </video>
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/logo_music.png" :alt="$t('culture.music.name')">
            <html-view tag="p" :value="$t('culture.music.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('culture.music.content')" />
            <div class="btn-wrap">
              <router-link
                :to="{ name: 'Music', params : { locale: $route.params.locale }}"
                class="btn-link"
              >
                {{ $t('culture.music.site') }}<icon-blank />
              </router-link>
              <!--<a
                href="/"
                class="btn-link"
                target="_blank"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '컬처',
                  label: '서비스링크_음악',
                  page: '서비스'})"
              >{{ $t('culture.music.site') }}<icon-blank /></a>-->
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import gtag from '@/mixins/gtag'
import { hashTitle } from '@/util'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    iconBlank: () => import('@/static/svg/blank.svg')
  },
  mixins: [gtag],
  methods: { hashTitle },
}
</script>
